export class ConfirmDialogPostbackHandler {
    constructor(public options: any) { }
    before: string[] = ["setIsPostbackRunning"]
    execute<T>(callback: () => Promise<T>, postBackOptions: any): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            //checks if the confirm dialog with that id is already in the viewmodel
            if (!("ConfirmDialog" in dotvvm.state)) {
                throw new Error("The ConfirmDialog property in the root viewmodel was not found!");
            }
            const dialog = document.getElementById("confirmDialog");
            if (!dialog) {
                throw new Error("The dialog with ID=confirmDialog was not found in the page!");
            }
            // show dialog
            dotvvm.patchState({
                ConfirmDialog: {
                    IsVisible: true,
                    Title: this.options.title,
                    MessageHtml: this.options.messageHtml,
                    Type: this.options.type,
                    AcceptButtonText: this.options.acceptButtonText,
                    CancelButtonText: this.options.cancelButtonText
                }
            });
            // bind handlers
            const acceptButton = dialog.querySelector("#acceptBtn");
            acceptButton.addEventListener("click", onAccepted);
            const cancelButton = dialog.querySelector("#cancelBtn");
            cancelButton.addEventListener("click", onCancelled);
            function onAccepted() {
                resolve(void 0);
                hideDialog();
            }
            function onCancelled() {
                hideDialog();
                reject(void 0);
            }
            function hideDialog() {
                // hide dialog
                dotvvm.patchState({
                    ConfirmDialog: {
                        IsVisible: false
                    }
                });
                // unbind handlers
                acceptButton.removeEventListener("click", onAccepted);
                cancelButton.removeEventListener("click", onCancelled);
            }
        }).then(() => callback());
    }
}